import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GenericResponseDTO, NuovaPraticaResultDTO, PagePratica, PraticaDettaglio, RichiestaPraticaDTO, TipoRicezioneOTP } from '../../shared/models/pratiche';

@Injectable({
  providedIn: 'root'
})
export class PraticheApiService {

  private baseUrl = `${environment.servicesPraticheUrl}/api/v1/__NO_COMUNE__/pratiche`;

  setSlugComune(slug: string) {
    this.baseUrl = `${environment.servicesPraticheUrl}/api/v1/${slug}/pratiche`;
  }

  private _codiceTipoPratica: string = '';

  constructor(private http: HttpClient) {}

  setCodiceTipoPratica(codice: string) {
    this._codiceTipoPratica = codice;
  }

  private getHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    if (this._codiceTipoPratica) {
      headers = headers.set('X-CodicePratica', this._codiceTipoPratica);
    }
    return headers;
  }

  addPraticaForm(
    pratica: any,
    documentoAnagrafica1?: File,
    documentoAnagrafica2?: File,
    documentoAnagrafica3?: File,
    documentoAnagrafica4?: File,
    documentoAnagrafica5?: File,
    documento1?: File,
    documento2?: File,
    documento3?: File,
    documento4?: File,
    documento5?: File,
    documento6?: File,
    documento7?: File,
    documento8?: File,
    documento9?: File,
    documento10?: File,
    screenPratica?: File,
  ): Observable<NuovaPraticaResultDTO> {
    const formData = this.buildFormData(
      pratica, documentoAnagrafica1, documentoAnagrafica2, documentoAnagrafica3,
      documentoAnagrafica4, documentoAnagrafica5, documento1, documento2, documento3,
      documento4, documento5, documento6, documento7, documento8, documento9, documento10,
      screenPratica
    );
    return this.http.post<NuovaPraticaResultDTO>(this.baseUrl, formData, { headers: this.getHeaders() });
  }

  addPraticAuthForm(
    pratica: any,
    documentoAnagrafica1?: File,
    documentoAnagrafica2?: File,
    documentoAnagrafica3?: File,
    documentoAnagrafica4?: File,
    documentoAnagrafica5?: File,
    documento1?: File,
    documento2?: File,
    documento3?: File,
    documento4?: File,
    documento5?: File,
    documento6?: File,
    documento7?: File,
    documento8?: File,
    documento9?: File,
    documento10?: File,
    screenPratica?: File,
  ): Observable<NuovaPraticaResultDTO> {
    const formData = this.buildFormData(
      pratica, documentoAnagrafica1, documentoAnagrafica2, documentoAnagrafica3,
      documentoAnagrafica4, documentoAnagrafica5, documento1, documento2, documento3,
      documento4, documento5, documento6, documento7, documento8, documento9, documento10,
      screenPratica
    );
    return this.http.post<NuovaPraticaResultDTO>(`${this.baseUrl}/auth`, formData, { headers: this.getHeaders() });
  }

  private buildFormData(
    pratica: any,
    documentoAnagrafica1?: File,
    documentoAnagrafica2?: File,
    documentoAnagrafica3?: File,
    documentoAnagrafica4?: File,
    documentoAnagrafica5?: File,
    documento1?: File,
    documento2?: File,
    documento3?: File,
    documento4?: File,
    documento5?: File,
    documento6?: File,
    documento7?: File,
    documento8?: File,
    documento9?: File,
    documento10?: File,
    screenPratica?: File,
  ): FormData {
    const formData = new FormData();
    formData.append('pratica', new Blob([JSON.stringify(pratica)], { type: 'application/json' }));

    if (documentoAnagrafica1 !== undefined) { formData.append('documentoAnagrafica1', documentoAnagrafica1); }
    if (documentoAnagrafica2 !== undefined) { formData.append('documentoAnagrafica2', documentoAnagrafica2); }
    if (documentoAnagrafica3 !== undefined) { formData.append('documentoAnagrafica3', documentoAnagrafica3); }
    if (documentoAnagrafica4 !== undefined) { formData.append('documentoAnagrafica4', documentoAnagrafica4); }
    if (documentoAnagrafica5 !== undefined) { formData.append('documentoAnagrafica5', documentoAnagrafica5); }
    if (documento1 !== undefined) { formData.append('documento1', documento1); }
    if (documento2 !== undefined) { formData.append('documento2', documento2); }
    if (documento3 !== undefined) { formData.append('documento3', documento3); }
    if (documento4 !== undefined) { formData.append('documento4', documento4); }
    if (documento5 !== undefined) { formData.append('documento5', documento5); }
    if (documento6 !== undefined) { formData.append('documento6', documento6); }
    if (documento7 !== undefined) { formData.append('documento7', documento7); }
    if (documento8 !== undefined) { formData.append('documento8', documento8); }
    if (documento9 !== undefined) { formData.append('documento9', documento9); }
    if (documento10 !== undefined) { formData.append('documento10', documento10); }
    if (screenPratica !== undefined) { formData.append('screenPratica', screenPratica); }

    return formData;
  }

  confermaOtp(codicePratica: string, otp: string): Observable<GenericResponseDTO> {
    return this.http.put<GenericResponseDTO>(`${this.baseUrl}/${codicePratica}/conferma-otp`, null, {
      params: { otp },
      headers: this.getHeaders()
    });
  }

  richiediOtp(codicePratica: string, tipoRicezioneOTP: TipoRicezioneOTP): Observable<GenericResponseDTO> {
    return this.http.put<GenericResponseDTO>(`${this.baseUrl}/${codicePratica}/richiedi-otp`, null, {
      params: { tipo_ricezione_otp: tipoRicezioneOTP },
      headers: this.getHeaders()
    });
  }

  getPdfReview(codicePratica: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${codicePratica}/pdf-review-pratica`, {
      responseType: 'blob',
      headers: this.getHeaders()
    });
  }

  confermaPdfReview(codicePratica: string): Observable<GenericResponseDTO> {
    return this.http.put<GenericResponseDTO>(`${this.baseUrl}/${codicePratica}/conferma-pdf-review`, null, { headers: this.getHeaders() });
  }

  getPratica(codicePratica: string): Observable<PraticaDettaglio> {
    return this.http.get<PraticaDettaglio>(`${this.baseUrl}/${codicePratica}`, {
      headers: this.getHeaders()
    });
  }

  getPratiche(codiceFiscale: string, page: number = 0, size: number = 100): Observable<PagePratica> {
    return this.http.get<PagePratica>(this.baseUrl, {
      params: { codice_fiscale: codiceFiscale, page: page.toString(), size: size.toString() },
      headers: this.getHeaders()
    });
  }
}
